import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux';
import { getProductCategories, getProductCategoriesDataClear, getSubProductCategoriesDataClear } from '../../redux/courses/actions';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { setJoyRideReq } from '../../redux/assignCourse/actions';
import { SessionKeys, getStepIndex } from '../../utils/AppUtils';


const CourseCategoryListingSection = ({
    isLoading,
    setIsLoading
}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const providerId = params.get('provider_id');
  console.log("providerId in course listing",providerId);


  const authBroker = useSelector((state) => state.auth.authBroker);
  const userRole = useSelector((state) => state.user.role);
  const isPremiumUser = useSelector(state => state.user.isPremiumUser);
  const productCategoriesData = useSelector(
    (state) => state.courses.productCategories
  );

  const [courseCategories, setCourseCategories] = useState([]);

  useEffect(()=>{
    if(sessionStorage.getItem(SessionKeys.IS_TOUR)==="YES"){
      setTimeout(()=>{
        window.scrollTo(0,0)
      },1000)
    }
  },[])

  useEffect(() => {
    if (sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" && !_.isEmpty(authBroker)) {
      const isGuest = authBroker.payload.user.role.includes('guest')
      const stepIndex = getStepIndex('#idCourseCat', userRole, isPremiumUser, isGuest);
      // dispatch(setJoyRideReq({ run: true, stepIndex: (userRole === 'manager' ? isPremiumUser ? 18 : 19 : isPremiumUser ? 17 : 8) }))
      dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex}))
    }
    // dispatch(getSubProductCategoriesDataClear());
    dispatch(getSubProductCategoriesDataClear());
    dispatch(getProductCategoriesDataClear());
  }, [authBroker])

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      setIsLoading(true)
      dispatch(
        getProductCategories({
          module: "getProductCategoryFromWoo",
          brokerId: authBroker.payload.user.company_id,
          type: 'course',
          provider_id: providerId ? providerId: '',
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        })
      );
    }
  }, [authBroker])

  useEffect(() => {
    // console.log("product categories", productCategoriesData, courseCategoriesDataBroker);
    if (
      !_.isEmpty(productCategoriesData)
    ) {
      setIsLoading(false)
      let categoryArray = [];
      if (
        productCategoriesData.status === "success"
      ) {
        if (productCategoriesData?.payload?.length > 0) {
          categoryArray = [...categoryArray, ...productCategoriesData.payload];
        }
        categoryArray = _.sortBy(categoryArray, 'categoryId')
        setCourseCategories(categoryArray);
      }


    }
  }, [productCategoriesData]);

  return (
    <>
        <section className='my-credit-points course-category-page'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12' id='categoryId'>
                <div className="events_banner">
                  <p className="label-heading_events mb-4">Categories</p>
                </div>
              </div>
            </div>
            <div id="idCourseCat" className='row mt-3'>

              {courseCategories?.map((item, index) => {
                return <div className='col-md-6 col-lg-4 col-xl-3 col-12 mb-4 cat-broker-box'>
                  {item.image ? <div className='catbox cursor-pointer' style={{
                    backgroundImage: `url(${item.image})`
                  }}
                    onClick={() => {
                      let url = `/courseListing?selectedCategory=${item.categoryId}&selectCourse=top`;
                      url = providerId ? `${url}&provider_id=${providerId}` : `${url}`;
                      console.log("uri",url)
                      sessionStorage.setItem('courseListUrl',url)
                      navigate(url);
                    }}>
                    <div className='cat-overlay'>
                      <div className='cat-title-course'>
                        {item?.categoryName}
                      </div>
                    </div>
                  </div>
                    :
                    <div className='catbox cursor-pointer without-img-course' style={{ backgroundColor: '#d9d9d9' }}
                      onClick={() => {
                        let url = `/courseListing?selectedCategory=${item.categoryId}&selectCourse=top`;
                        url = providerId ? `${url}&provider_id=${providerId}` : `${url}`;
                        sessionStorage.setItem('courseListUrl',url)
                        navigate(url);
                      }}>
                      <div className='cat-overlay'>
                        <div className='cat-title-course'>
                          {item?.categoryName}
                        </div>
                      </div>
                    </div>}
                </div>
              })
              }

            </div>
          </div>
        </section>
    </>
  )
}

export default CourseCategoryListingSection